import gql from 'graphql-tag';

export const VISIT_FIELDS = gql`
  fragment VisitFields on OdProtosTrippyData_Visit {
    id
    assignedUserToken
    assignedUser {
      fullName
    }
    assignedOrganizationToken
    assignedOrganization {
      name
    }
    address {
      uuid
      street
      city
      state
      postalCode
      unitType
      unitNumber
    }
    createdAt
    enrollment {
      id
      metadata {
        default_field_user {
          fullName
          token
        }
      }
    }
    visitType {
      id
      label
    }
    notes
    scheduledStartAt
    checkInAt
    checkOutAt
    rejectedAt
  }
`;
